"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FiltersFieldsEnum = void 0;
var FiltersFieldsEnum;
(function (FiltersFieldsEnum) {
    FiltersFieldsEnum["Segment"] = "segment";
    FiltersFieldsEnum["Type"] = "type";
})(FiltersFieldsEnum || (exports.FiltersFieldsEnum = FiltersFieldsEnum = {}));
